import React from 'react';
import {
  TendersContainer,
  TendersCard as StyledTendersCard,
  TendersHeader,
  TendersIconWrapper,
  TendersIcon,
  TendersValue,
} from './TenderCard.styles';

const tendersData = [
  { title: "Active Tenders", icon: "/Icons/active-tenders.svg", payloadKey: 'active_tenders' },
  { title: "Total Tenders", icon: "/Icons/total-tender.svg", payloadKey: 'total_tenders' },
  { title: "Done This Week", icon: "/Icons/week-month-tender.svg", payloadKey: 'this_week' },
  { title: "Done This Month", icon: "/Icons/week-month-tender.svg", payloadKey: 'this_month' },
];

const renderItem = (item, index, data) => {
  return (
    <StyledTendersCard key={index}>
      <TendersHeader>
        <TendersIconWrapper>
          <TendersIcon src={item.icon} alt={item.title} />
        </TendersIconWrapper>
        {item.title}
      </TendersHeader>
      <TendersValue>{data && data[item.payloadKey] || '...'}</TendersValue>
    </StyledTendersCard>
  )
}

const TendersSection = ({data}) => (
  <TendersContainer>
    {tendersData.map((item, index) => (
      renderItem(item, index, data)
    ))}
  </TendersContainer>
);

export default TendersSection;